import { useContext } from 'react'

import { LayoutToolsContext } from '@component/Layout/Tools'

import { LayoutToolsContextProps } from '@base/@types/components/Layout/Tools'

export default function useTools(): LayoutToolsContextProps {
  const context = useContext(LayoutToolsContext)

  return context
}
